// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__EX0fJ","colMin":"styles_colMin__1D_zE","colCheckbox":"styles_colCheckbox__SgCZD"};